import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { PlaybookCommunicationService } from '../../services/playbook-communication.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Modalconfig, devicePixelRatio, DefaultLanguageId } from 'src/app/shared/constants';
import { ConfirmationModelComponent } from 'src/app/shared/components/confirmation-model/confirmation-model.component';
import { Subscription } from 'rxjs';
import Viewer from 'viewerjs';
import { PlaybookManifest } from 'src/app/shared/model/container.models';
import { SendIframeUrlService } from 'src/app/shared/services/send-iframe-url/send-iframe-url.service';

@Component({
    selector: 'app-apply-page-template',
    templateUrl: './apply-page-template.component.html',
    styleUrls: ['./apply-page-template.component.scss'],
    standalone: false
})
export class ApplyPageTemplateComponent implements OnInit {

  imageViewer: Viewer;
  devicePixelRatio = devicePixelRatio;
  companyId: number;
  pageId: number;
  isDraftMode: boolean;
  playbookId: number;
  templateGroups = [];
  pageTemplates = [];
  shownTemplates = [];
  selectedGroups: any[];
  confirmationModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  templatesSortBy: string;
  pageFrom;

  constructor(
    private modalRef: BsModalRef,
    private commonHttpService: CommonHttpService,
    private modalService: BsModalService,
    private commService: PlaybookCommunicationService,
    private location: Location,
    private sendIframeUrlService: SendIframeUrlService
  ) { }

  ngOnInit() {
    $('#templateGrp').attr('size', this.templateGroups.length);
    this.getGroupAndTemplates();
    this.templatesSortBy = '1';
  }

  /**
   * To fetch page templates and groups
   */
  getGroupAndTemplates() {
    // groups
    this.commonHttpService.get({
      uri: `/api/PageTemplates/GetPageTemplateGroupsWithPageTemplates?companyId=${this.companyId}`
    }).subscribe((response: any) => {
      this.templateGroups = response;

    });
  }

  /**
   * To sort categories and templates alphabetically
   * @param items categories or templates
   */
  sortAlphabetically(items) {
    return items.sort((a, b) => {
      return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });
  }

  /**
   * To sort templates according to dropdown
   * @param items templates
   */
  sortTemplates(items) {
    switch (this.templatesSortBy) {
      case '1': {
        return items.sort((a, b) => a.name.localeCompare(b.name));
      }
      case '2': {
        return items.sort((a, b) => a.createdByName ? a.createdByName.localeCompare(b.createdByName) : 0);
      }
      case '3': {
        return items.sort((a, b) => new Date(b.lastUpdatedAt) as any - +new Date(a.lastUpdatedAt) as any);
      }
      default:
        return items;
    }
  }

  /**
   * To set the template image in template list
   */
  setTemplateImgSrc(template) {
    return `/api/Assets/Image/${template.previewImageKey}?width=120`;
  }

  /**
   * To filter the displayed template list based on selected template groups
   */
  filterTemplates() {
    const filteredTemp = [];
    if (this.selectedGroups.includes('-1')) {
      this.templateGroups.map(groups => {
        filteredTemp.push(...groups.pageTemplates)
      })
    } else {
      this.selectedGroups.filter(groupId => {
        const selectedGroup = this.templateGroups.find(group => group.id == groupId)
        if (selectedGroup) {
          filteredTemp.push(...selectedGroup.pageTemplates)
        }
      })
    }
    this.shownTemplates = this.sortTemplates(filteredTemp);
  }

  /**
   * To apply the page template
   * @param template page template to be applied
   */
  selectTemplate(template) {
    const initialState = {
      msg: 'Are you sure you want to apply ' + template.name + ' template?'
    };
    this.confirmationModalRef = this.modalService.show(ConfirmationModelComponent,
      Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
    this.confModalSubsciber = this.confirmationModalRef.content.onclose.subscribe((isDelete: boolean) => {
      if (isDelete) {
        this.commonHttpService.post({
          uri: '/api/PageTemplates/ApplyPageTemplate',
          object: {
            pageId: this.pageId,
            pageTemplateId: template.id,
            playbookId: this.playbookId,
            isDraftMode: this.isDraftMode
          }
        }).subscribe(response => {
          // to fetch playbook manifest after template is set
          this.commService.setPlaybookManifest(PlaybookManifest.PAGE_TEMPLATE);
          this.closeModal();
        });
      }
      this.confirmationModalRef.hide();
      this.confModalSubsciber.unsubscribe();
    });
  }

  /**
   * To attach image viewer on page template image click
   * @param template page template
   */
  attachViewer(template) {
    const imagecontainer = document.getElementById('viewerJsImageContainer');
    const options = {
      toolbar: false,
      tooltip: true,
      movable: true,
      navbar: false,
      transition: false,
      rotatable: false,
      scalable: false,
      title: false
    };
    imagecontainer.innerHTML = '';
    // azure issue check
    this.commonHttpService.get<any>({
      uri:  `/api/Assets/Image/${template.previewImageKey}?width=1024&ratio=${this.devicePixelRatio}`,
      message: {
        showMessage: false
      }
    }).subscribe((imageDataUrl) => {
      const html = `<div id="viewerjsHolderDiv"><ul id="image-group-pageTemp"><li>
      <img src="${imageDataUrl.replace(/ /g, '%20')}" /></li></ul></div>`;
      imagecontainer.innerHTML = html;
      this.imageViewer = new Viewer(document.getElementById(`image-group-pageTemp`), options);
      this.imageViewer.show();
    });
   
  }

  /**
   * To close the modal
   */
  closeModal() {
    let returnUrl = window.location.pathname.replace('/pagetemplate/choose', '') + '?languageId='+ DefaultLanguageId;
    if (this.pageFrom) {
      returnUrl = returnUrl + '&pageFrom=' + this.pageFrom;
    }
    this.location.go(returnUrl);
    this.sendIframeUrlService.sendUrlToParent(returnUrl);
    this.modalRef.hide();
  }
}
